import React from 'react';
import { type PanelDegreeInformation } from '../../../../../graphql/GSAssessment';
import { PANEL_DETAIL_APPLICATION_TEXT } from '../../../../../lang';

type PanelDegreeProps = {
  panelDegreeInformation: PanelDegreeInformation;
};

const PanelDegree: React.FunctionComponent<PanelDegreeProps> = (
  props: PanelDegreeProps,
) => {
  const {
    name,
    degreeLevel,
    originalGPA,
    originalGPAOutOf,
    awardClassification,
    rankings,
    gpa,
    currentStudy,
    classRanking,
    classRankingOutOf,
  } = props.panelDegreeInformation;

  // display N/A if the applicant does not have a second degree
  if (!name || name === 'N/A')
    return (
      <div className="flex flex-col justify-center">
        <i className="text-[#951D1D]">N/A</i>
        <hr className="my-1" />
        <i className="text-[#951D1D]">N/A</i>
      </div>
    );

  const convertedGpa = !gpa ? 'N/A' : Number(gpa).toFixed(2) + '/4.0';
  const originGpa =
    !Number(originalGPA) || !Number(originalGPAOutOf)
      ? 'N/A'
      : `${originalGPA}/${originalGPAOutOf}`;

  const classRank =
    !Number(classRanking) || !Number(classRankingOutOf)
      ? 'N/A'
      : `${classRanking}/${classRankingOutOf}`;

  return (
    <div className="flex flex-col justify-center">
      <p>
        {name}
        <br />
        {`(${degreeLevel})`}
        <br />
        <b>{convertedGpa}</b>
        {' | '}
        <b>{originGpa}</b>
        {' | '}
        <b>{classRank}</b>
      </p>

      <hr className="my-1" />
      <div className="text-[#951D1D] flex flex-col">
        {currentStudy && <i>{PANEL_DETAIL_APPLICATION_TEXT.CURRENT_STUDY}</i>}
        <i>{awardClassification}</i>
        {rankings?.map((rank, index) => (
          <b key={index}>
            {rank.rankingSystem}:&nbsp;
            {rank.originalRanking ?? '-'}
          </b>
        ))}
      </div>
    </div>
  );
};
const MemoizedPanelDegree = React.memo(PanelDegree);
export { MemoizedPanelDegree };
